import {SalesAttachmentTypeEnum} from 'common/constants';
import {DayReportEntryType} from 'common/interfaces/iDayReports';
import {SalesEntryType} from 'common/interfaces/ishiftReport';

export const getSalesTypeFromAttachment = (
  attType: SalesAttachmentTypeEnum | undefined | null,
): SalesEntryType | undefined => {
  if (!attType) {
    return;
  }
  switch (attType) {
    case SalesAttachmentTypeEnum.CASH_ENTRY:
      return 'cashEntry';
    case SalesAttachmentTypeEnum.COUPON_SALES:
      return 'couponSales';
    case SalesAttachmentTypeEnum.DROPS_ENTRY:
      return 'dropsEntry';
    case SalesAttachmentTypeEnum.LOSS_ENTRY:
      return 'lotterySales';
    case SalesAttachmentTypeEnum.LOTTERY_PO:
      return 'lotteryPO';
    case SalesAttachmentTypeEnum.LOTTERY_SALES:
      return 'lotterySales';
    case SalesAttachmentTypeEnum.MISC_PO:
      return 'miscPO';
    case SalesAttachmentTypeEnum.MO_ENTRY:
      return 'moSales';
    case SalesAttachmentTypeEnum.VOID_ENTRY:
      return 'voids';
  }
};

export const getAttachmentTypeFromSalesType = (
  type: SalesEntryType | undefined | null,
): SalesAttachmentTypeEnum | undefined => {
  if (!type) {
    return;
  }
  switch (type) {
    case 'cashEntry':
      return SalesAttachmentTypeEnum.CASH_ENTRY;
    case 'lotterySales':
      return SalesAttachmentTypeEnum.LOTTERY_SALES;
    case 'moSales':
      return SalesAttachmentTypeEnum.MO_ENTRY;
    case 'lotteryPO':
      return SalesAttachmentTypeEnum.LOTTERY_PO;
    case 'miscPO':
      return SalesAttachmentTypeEnum.MISC_PO;
    case 'couponSales':
      return SalesAttachmentTypeEnum.COUPON_SALES;
    case 'voids':
      return SalesAttachmentTypeEnum.VOID_ENTRY;
    case 'dropsEntry':
      return SalesAttachmentTypeEnum.DROPS_ENTRY;
    case 'dayReportSales':
      return SalesAttachmentTypeEnum.DAY_REPORT_SALES;
    case 'dayReportCashPO':
      return SalesAttachmentTypeEnum.DAY_REPORT_CASH_PO;
    case 'dayReportCashDeposit':
      return SalesAttachmentTypeEnum.DAY_REPORT_CASH_DEP;
    case 'dayGasReport':
      return SalesAttachmentTypeEnum.DAY_REPORT_GAS_SALES;
  }
};

export const getAttachmentTypeFromDayReportEntryType = (
  type: DayReportEntryType | undefined | null,
): SalesEntryType | undefined => {
  if (!type) {
    return;
  }
  switch (type) {
    case 'salesEntry':
      return 'dayReportSales';
    case 'cashPO':
      return 'dayReportCashPO';
    case 'cashDeposit':
      return 'dayReportCashDeposit';
    case 'gas':
      return 'dayGasReport';
  }
};
